import app from '@/app';

/* @ngInject */
const resource = abstractResource => abstractResource('solution');

app.factory('Solution', resource);
